import React, {useEffect, useState} from "react";
import {accountService, patientService} from "api";
import Child from "./Child";

import {getRoleApi} from "redux/reducer/account";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setButtonsHeader} from "redux/reducer/common";
import {Button} from "antd";
import {tabKeys} from "types/enums";

type Info = {
  name: string;
  age: number;
  major: string;
};
type DataFromChild = {
  value: string;
};
const Parent = () => {
  const [dataFromChild, setDataFromChild] = useState<DataFromChild>();
  const dispatch = useAppDispatch();
  // Lấy giá trị active tab
  const activeTab = useAppSelector(state => state.common.activeTab);
  const button = () => (
    <Button className="btn-sub" type="ghost">
      Button tab {tabKeys.SAMPLE.PASS_DATA}{" "}
    </Button>
  );
  useEffect(() => {
    // Đẩy button lên header
    if (activeTab == tabKeys.SAMPLE.PASS_DATA) {
      // // check active tab
      dispatch(setButtonsHeader([button()]));
    }
  }, [activeTab]);
  const data: Info = {
    name: "TD.411",
    age: 23,
    major: "FE",
  };

  const getDataFromChild = (value: DataFromChild) => {
    setDataFromChild(value);
  };
  return (
    <div className="parent">
      <div className="container">
        <div style={{fontWeight: 600, textAlign: "center"}}>Parent</div>
        <div>{dataFromChild?.value}</div>
        <Child info={data} callback={getDataFromChild}></Child>
      </div>
    </div>
  );
};
export default Parent;
